import store from "@/store/";
import partnerHelpers from "@/helpers/partnerHelpers";

export default async ({_from, to, next}) => {
    console.log('middleware - themed');
    if(to.query.agent !== undefined)
    {
        const agent = to.query.agent;
        store.commit('subscription/setAgentCustomId', agent);

        const partnerSettings = await partnerHelpers.getPartnerSettings(agent); // ER-1212.
        store.commit("subscription/setAgentAllowBxlResi", partnerSettings.allow_bxl_resi, { root: true });
    }

    next();
}



// WEBPACK FOOTER //
// ./src/router/middleware/themed.js